import {
  Auth0RoleZod,
  userAssignedRoleSchema,
  userAuth0IdSchema,
} from './UserRoleDTO';
import { z } from 'zod';

export const userBusinessSchema = z.object({
  userId: z.number(),
  businessId: z.number(),
  receiveStatus: z.boolean().optional(),
});

export const createUserDTOSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  podID: z.number().optional(),
  email: z
    .string()
    .email()
    .transform((val) => val.toLowerCase()),
  businessIDs: z.number().array().optional(),
  notificationEmail: z
    .string()
    .email()
    .transform((val) => val.toLowerCase()),
  auth0Roles: Auth0RoleZod.array(),
  acceptedInvite: z.boolean().optional(),
  inviteSentTime: z.string().optional(),
  receiveLeads: z.boolean().optional(),
  receiveStatus: z.boolean().optional(),
});

export const PodUserSchema = z.object({
  podId: z.number(),
  userId: z.number(),
  createdAt: z.string().nullable(),
});

export const digestUserDTOSchema = createUserDTOSchema
  .omit({ podID: true, businessIDs: true })
  .extend({
    userId: z.number(),
    theme: z.number(),
    acceptedInvite: z.boolean(),
    fbAccountId: z.string().nullable(),
    fbAccessToken: z.string().nullable(),
    profilePic: z.string().nullable(),
    inviteToken: z.string().nullable(),
    inviteSentTime: z.string().nullable(),
    privacyAddendum: z.string().nullable(),
    phone: z.string().nullable(),
    calendlyLink: z.string().nullable(),
    createdAt: z.string().nullable(),
    updatedAt: z.string().nullable(),
    deletedAt: z.string().nullable(),
    auth0Ids: userAuth0IdSchema.array().optional(),
    auth0Roles: Auth0RoleZod.array().optional(),
    businesses: userBusinessSchema.array().optional(),
    assignedRoles: userAssignedRoleSchema.array().optional(),
    pods: PodUserSchema.array().optional(),
    googleRefreshToken: z.string().nullable(),
  });

export type CreateUserDTO = z.infer<typeof createUserDTOSchema>;
export type DigestUser = z.infer<typeof digestUserDTOSchema>;

export const updateUserSchema = createUserDTOSchema
  .omit({ auth0Roles: true, acceptedInvite: true, inviteSentTime: true })
  .extend({
    auth0Roles: Auth0RoleZod.array().optional(),
    privacyAddendum: z.string().nullable(),
  });

export type UpdateUser = z.infer<typeof updateUserSchema>;

export type UpdateUserDTO = Partial<UpdateUser>;
